import axios from "axios";
import React, { useEffect, useState } from "react";
import Loading from "../../Components/global/Loading";
import { IconButton, Modal, Pagination, Paper } from "@mui/material";
import { HeadingH3 } from "../../Components/global/Headings";
import { TABLE_DATA, TABLE_HEAD } from "../../styles/tableStyle";
import { useDispatch, useSelector } from "react-redux";
import { getAllTelecallers } from "../../redux/actions/telecaller";
import { useNavigate } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";

export default function ContactsList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    contactsList,
    loading,
    count: totalCounts,
  } = useSelector((state) => state?.telecaller);
  const [showDetailsModal, setShowDetailsModal] = useState("");
  const [selectedContact, setSelectedContact] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    dispatch(getAllTelecallers(pageNo, pageSize));
  }, [pageNo, pageSize]);

  const handleSearchTelecaller = () => {};

  console.log(showDetailsModal);

  return (
    <div>
      <Paper className="p-2">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-4">
            <HeadingH3 title="Contacts List" />
          </div>
          <div className="flex items-center gap-4">
            {/* Search */}
            {/* <div className="flex items-center rounded-lg border">
              <input
                className="w-full border-none focus:outline-none"
                value={searchParams}
                onChange={(e) => setSearchParams(e.target.value)}
                placeholder="Search here"
                defaultValue={searchParams}
              />

              <IconButton onClick={handleSearchTelecaller}>
                <IoSearch />
              </IconButton>
            </div> */}

            {/* Page size */}
            <div className="flex gap-2 items-center border-2 rounded-lg rounded-r-xl pl-2">
              <p>Size</p>
              <select
                className="rounded-lg rounded-l-none focus:border-primary focus:outline-primary"
                value={pageSize}
                onChange={(e) => setPageSize(e.target.value)}
                defaultValue={pageSize}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={150}>150</option>
                <option value={200}>200</option>
                <option value={250}>250</option>
              </select>
            </div>
          </div>
        </div>
      </Paper>

      <Paper className="p-4 mt-4">
        <table class="w-full border-collapse border border-slate-400">
          <thead>
            <tr>
              <th class={`${TABLE_HEAD}`}>SN</th>
              <th class={`${TABLE_HEAD}`}>Full Name</th>
              <th class={`${TABLE_HEAD}`}>Mobile No.</th>
              <th class={`${TABLE_HEAD}`}>Email Id</th>
              <th class={`${TABLE_HEAD}`}>Message</th>
              <th class={`${TABLE_HEAD}`}>Contacted At</th>
            </tr>
          </thead>
          <tbody>
            {contactsList?.map((item, index) => (
              <tr
                key={index}
                className="cursor-pointer"
                onClick={() => {
                  setSelectedContact(item);
                  setShowDetailsModal(true);
                }}
              >
                <td class={`${TABLE_DATA} font-semibold text-center`}>
                  {(pageNo - 1) * pageSize + ++index}.
                </td>
                <td class={`${TABLE_DATA} font-semibold`}>{item?.name}</td>
                <td class={`${TABLE_DATA} text-center`}>{item?.mobile}</td>
                <td class={`${TABLE_DATA}`}>{item?.email}</td>
                <td class={`${TABLE_DATA}`}>{item?.message}</td>
                <td class={`${TABLE_DATA} text-center`}>
                  {new Date(item?.createdAt)?.toLocaleString("en-In")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Paper>

      {/* Pagination */}
      <div className="flex justify-center mt-10">
        <Pagination
          count={Math.ceil(totalCounts / pageSize)}
          page={pageNo}
          variant="outlined"
          shape="rounded"
          onChange={(event, value) => setPageNo(value)}
        />
      </div>
      {loading && <Loading />}
      <ShowContactModal
        open={showDetailsModal}
        setOpen={setShowDetailsModal}
        contactDetails={selectedContact}
      />
    </div>
  );
}

const ShowContactModal = ({ open, setOpen, contactDetails }) => {
  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <div className="h-[100vh] flex items-center justify-center">
        <Paper sx={{ borderRadius: 5 }} className="p-4 w-[60%] relative">
          <div className="absolute top-2 right-2">
            <IconButton onClick={() => setOpen(false)}>
              <AiOutlineClose />
            </IconButton>
          </div>

          {/* Contact Details */}
          <div>
            <h1 className="text-2xl font-semibold text-center text-primary">
              Contact Details
            </h1>

            <div className="mt-10 flex flex-col gap-4">
              <div className="grid grid-cols-2 gap-2">
                <p>Full Name</p>
                <p>{contactDetails?.name}</p>
              </div>

              <div className="grid grid-cols-2 gap-2">
                <p>Mobile No</p>
                <p>{contactDetails?.mobile}</p>
              </div>

              <div className="grid grid-cols-2 gap-2">
                <p>Email Address</p>
                <p>{contactDetails?.email}</p>
              </div>

              <div className="grid grid-cols-2 gap-2">
                <p>Message</p>
                <p>{contactDetails?.message}</p>
              </div>

              <div className="grid grid-cols-2 gap-2">
                <p>Contacted At</p>
                <p>
                  {new Date(contactDetails?.createdAt)?.toLocaleString("en-In")}
                </p>
              </div>
            </div>
          </div>
        </Paper>
      </div>
    </Modal>
  );
};
